module.exports = __webpack_public_path__ + "img/icon-81.d124e011.png";